import {
  Box,
  Button,
  Flex,
  SimpleGrid,
  VStack,
  useToast
} from "@chakra-ui/react";
import axios from "axios";
import { Formik, Form as FormikForm } from "formik";
import { useCallback, useEffect, useState } from "react";
import { useStoreEdited } from "../../../../config/component/customHooks/useStoreEdited";
import CustomInput from "../../../../config/component/CustomInput/CustomInput";
import Loader from "../../../../config/component/Loader/Loader";
import {
  primaryButtonHoverStyle,
  primaryButtonStyle,
} from "../../../../globalStyles";
import store from "../../../../store/store";
import { pickMatchedFields } from "../../utils/function";
import DueDateSync from "./DueDateSync";
import { MultiHedgeDealExport } from "./MultiHedgeDealExport";
import {
  dummyExporPOtData,
  exportRegisterexposureTypeOptions,
} from "./utils/constant";
import { normalizeDate } from "./utils/function";
import { getExportRegisterValidationSchema } from "./utils/validationSchema";
// import { toJS } from "mobx";
import { extractFieldValue } from "../../../../config/constant/function";
import ForecastExposureFields from "./ForecastExposureFields";

const ExposureForm = ({ submitExportForm, editData, originalData, onClose }: any) => {
  const { auth: { bussinessUnitsData, currenciesData, banksData } } = store
  const [showError, setShowError] = useState(false);
  const [loading, setLoading] = useState(true);
  const [, setSubmitAttempted] = useState(false);
  const [poData, setPoData] = useState<any[]>([]);
  const url = process.env.REACT_APP_FX_BASE_URL;
  const [selectedExposureType, setSelectedExposureType] = useState<string>("");
  const toast = useToast();
  const isEdit = Boolean(editData);
  const { storeEdited, editLoading } = useStoreEdited();
  const [poBalance, setPoBalance] = useState<number>(0);
  

  const validationSchema = getExportRegisterValidationSchema(isEdit, poBalance);

const fetchPoBalance = async (poNumber: string) => {
  try {
    const response: any = await axios.post(`${url}/exportregister/pobalance/`, {
      register: "export",
      exposureType: selectedExposureType,
      poNumber,
    });
    // setPoBalance(response?.data?.data?.remainingBalance || 0);
    setPoBalance(response?.data?.data?.remainingBalance || 0);
  } catch (error:any) {
    console.error("Error fetching PO balance:", error.message);
  }
};

 

  const fetchPoDetails = useCallback(async () => {
    setLoading(true);
    try {
      const response = await axios.post(`${url}/exportregister/polist/`);
      const result = response.data?.data || [];

      const withSerial = result.map((item: any, idx: number) => ({
        ...item,
        sno: idx + 1,
      }));

      const exportRegOptions = withSerial.map((item: any) => ({
        label: item.poNo,
        value: item.poNo,
        ...item,
      }));

      // ✅ Use API data if available, else dummy data
      if (exportRegOptions.length > 0) {
        setPoData(exportRegOptions);
      } else {
        setPoData(
          dummyExporPOtData.map((item: any) => ({
            ...item,
            label: item.poNo,
            value: item.poNo,
          }))
        );
      }
    } catch (error) {
      console.error("Error fetching PO details:", error);
      // ✅ Fallback to dummy data on error
      setPoData(
        dummyExporPOtData.map((item: any) => ({
          ...item,
          label: item.poNo,
          value: item.poNo,
        }))
      );
    } finally {
      setLoading(false);
    }
  }, [url]);

  useEffect(() => {
    fetchPoDetails();
  }, [fetchPoDetails]);

  const handleFormSubmit = (handleSubmit: any, errors: any) => {
    setShowError(true);
    setSubmitAttempted(true);
    if (Object.keys(errors).length > 0) {
      const firstError = Object.values(errors)[0] as string;
      toast({
        title: "Validation Error",
        description: firstError || "Please fill all required fields correctly",
        status: "error",
        duration: 4000,
        isClosable: true,
        position: "top-right",
      });
    }
    handleSubmit();
  };

  // console.log('the edit data is', editData)
  return (
    <Box mx="auto" m={5} borderRadius="2xl">
      {loading && <Loader />}
      {!loading && (
        <Formik
          initialValues={{
            exposureType: editData?.exposureType || "",
            poNo: editData?.poNo || "",
            poDate: normalizeDate(editData?.poDate),
            invoiceDate: normalizeDate(editData?.invoiceDate),
            blDate: normalizeDate(editData?.blDate),
            dueDate: normalizeDate(editData?.dueDate),
            partyName: editData?.partyName || "",
            bank: banksData.find((bank: any) => bank.value === editData?.bank) || {},
            businessUnit: bussinessUnitsData.find((dt: any) => dt.value === editData?.businessUnit) || {},
            currency: currenciesData.find((dt: any) => dt.value === editData?.currency) || {},
            invoiceNo: editData?.invoiceNo || "",
            paymentTerms: editData?.paymentTerms || "",
            amount: editData?.amount || "",
            budgetRate: editData?.budgetRate || "",
            remark: editData?.remark || "",
             hedgeDeals: editData?.hedgeDeals || [],
  outstandingAmount: editData?.outstandingAmount || "",
            // hedgeDeals: editData?.hedgeDeals || [],
          }}
          validationSchema={validationSchema}
          enableReinitialize={true}
          onSubmit={async (values, actions) => {
            values = extractFieldValue(values)
             if (values.bank && typeof values.bank === "object") {
    values.bank = values.bank.value;  // "HDFC"
  }
            if (isEdit) {
              const { original, updated } = pickMatchedFields(
                originalData,
                values,
                editData?.rowId
              );

              const payload = {
                register: "export",
                data: [
                  {
                    original,
                    updated,
                    rowId: editData?.rowId, // optional if backend still expects it here
                  },
                ],
              };

              try {
                await storeEdited(payload, onClose);
                actions.resetForm();
                actions.setSubmitting(false);
              } catch (error) {
                actions.setSubmitting(false);
              }

              return;
            }
            setShowError(true);
            submitExportForm(values, actions, "form");
          }}
        >
          {({
            values,
            handleChange,
            setFieldValue,
            isSubmitting,
            errors,
            touched,
            handleSubmit,
          }: any) => {
            // console.log('the values are', values)
            return (
              <FormikForm>
                <VStack spacing={6} align="stretch">
                  <SimpleGrid columns={[1, null, 2]} spacing={8}>
                    <CustomInput
                      label="Exposure Type"
                      name="exposureType"
                      type="select"
                      options={exportRegisterexposureTypeOptions}
                      value={exportRegisterexposureTypeOptions.find(
                        (option) => option.value === values.exposureType
                      )}
                      onChange={(selectedOption) => {
                        handleChange({
                          target: {
                            name: "exposureType",
                            value: selectedOption.value,
                          },
                        });

                        if (selectedOption.value === "confirmed_order") {
                          setFieldValue("poNo", "");
                          setFieldValue("poDate", "");
                          setFieldValue("partyName", "");
                          setFieldValue("bank", "");
                          setFieldValue("businessUnit", "");
                          setFieldValue("paymentTerms", "");
                          setFieldValue("currency", "");
                          setFieldValue("budgetRate", "");
                        } else {
                          setFieldValue("poNo", "");
                          setFieldValue("poDate", "");
                          setFieldValue("partyName", "");
                          setFieldValue("bank", "");
                          setFieldValue("businessUnit", "");
                          setFieldValue("paymentTerms", "");
                          setFieldValue("currency", "");
                          setFieldValue("budgetRate", "");
                        }
                        setSelectedExposureType(selectedOption.value);
                      
                        // fetchPoBalance(selectedOption.value);
                      }}
                      showError={showError}
                      error={touched.exposureType && errors.exposureType}
                      required={true}
                    />
                  </SimpleGrid>
                  {values.exposureType === "forecast" ? (

                    <ForecastExposureFields
                    values={values}
      handleChange={handleChange}
      touched={touched}
      errors={errors}
      showError={showError}
      currenciesData={currenciesData}
      bussinessUnitsData={bussinessUnitsData}
      setFieldValue={setFieldValue}
      />
    ):(
    <>
                  <SimpleGrid columns={[1, null, 2]} spacing={8}>

                    {values.exposureType === "confirmed_order" ? (
                      <CustomInput
                        label="PO No"
                        placeholder="Enter PO No"
                        name="poNo"
                        type="text"
                        value={values.poNo}
                        onChange={handleChange}
                        error={touched.poNo && errors.poNo}
                        showError={showError}
                        required={true}
                      />
                    ) : (

                      <CustomInput
                        label="PO No"
                        placeholder="Select PO No"
                        name="poNo"
                        type="select"
                        options={poData.map((item: any) => ({
                          label: item.poNo,
                          value: item.poNo
                        }))}
                        value={
                          poData.find((option: any) => option.value === values.poNo) || null
                        }
                        onChange={(selectedOption) => {
                          const selectedPo = poData.find(
                            (item: any) => item.poNo === selectedOption.value
                          );

                          setFieldValue("poNo", selectedOption.value);

                          if (selectedPo) {
                            // convert date
                            const formatDate = (d: string) => {
                              if (!d) return "";
                              if (d.includes(".")) {
                                const [day, month, year] = d.split(".");
                                return `${year}-${month}-${day}`;
                              }
                              return d;
                            };

                            setFieldValue("poDate", formatDate(selectedPo.poDate));
                            setFieldValue("partyName", selectedPo.partyName);
                            setFieldValue("bank", selectedPo.bank);
                            setFieldValue("businessUnit", selectedPo.businessUnit);
                            setFieldValue("paymentTerms", selectedPo.paymentTerms);
                            setFieldValue("currency", selectedPo.currency);
                            setFieldValue("budgetRate", selectedPo.budgetRate);
                            setFieldValue(
                              "outstandingAmount",
                              selectedPo.outStandingAmount || 0
                            );
                          }
                            if (selectedExposureType === "shipment") {
                          fetchPoBalance(selectedOption.value);
                        }
                        }}
                        required={true}
                        error={touched.poNo && errors.poNo}
                        showError={showError}
                      />
                    )}
                    <CustomInput
                      label="PO Date"
                      name="poDate"
                      type={selectedExposureType === "shipment" ? "text" : "date"}
                      placeholder="PO Date"
                      value={values.poDate}
                      onChange={handleChange}
                      error={touched.poDate && errors.poDate}
                      showError={showError}
                      required={true}
                      disabled={selectedExposureType === "shipment"}
                    />
                    <CustomInput
                      label="Party Name"
                      name="partyName"
                      placeholder="Enter Party Name"
                      value={values.partyName}
                      onChange={handleChange}
                      error={touched.partyName && errors.partyName}
                      showError={showError}
                      required={true}
                      disabled={selectedExposureType === "shipment"}
                    />

                     {selectedExposureType === "shipment" ? (
                       <CustomInput
                       label="Business Unit"
                       name="businessUnit"
                       placeholder="Enter Bank Name"
                       value={values.businessUnit}
                       onChange={handleChange}
                       error={touched.businessUnit && errors.businessUnit}
                       disabled={selectedExposureType === "shipment"}
                       showError={showError}
                       required={true}
                       />
                      ) : (
                        
                        <CustomInput
                          label="Business Units"
                          name="businessUnit"
                          placeholder="Units"
                          type="select"
                          options={bussinessUnitsData}
                          value={values.businessUnit}
                          onChange={(option) =>
                            handleChange({
                              target: { name: "businessUnit", value: option },
                            })
                          }
                          error={touched.businessUnit && errors.businessUnit}
                          showError={showError}
                          required={true}
                          disabled={selectedExposureType === "shipment"}
                          />
                    )}
                    {selectedExposureType === "shipment" ? (
                      <CustomInput
                        label="Bank"
                        // type="select"
                        name="bank"
                        placeholder="Enter Bank Name"
                        // options={banks}
                        value={values.bank}
                        onChange={handleChange}
                        error={touched.bank && errors.bank}
                        disabled={selectedExposureType === "shipment"}
                        showError={showError}
                        required={true}
                      />
                    ) : (
                      <CustomInput
                        label="Bank"
                        type="select"
                        name="bank"
                        placeholder="Enter Bank Name"
                        options={banksData}
                        value={values.bank}
                        onChange={(option) =>
                          handleChange({
                            target: { name: "bank", value: option },
                          })
                        }
                        error={touched.bank && errors.bank}
                        disabled={selectedExposureType === "shipment"}
                        showError={showError}
                        required={true}
                      />
                    )}
                    {selectedExposureType === "shipment" && (
                      <>
                        <CustomInput
                          label="Invoice No"
                          name="invoiceNo"
                          placeholder="Enter Invoice No"
                          value={values.invoiceNo}
                          onChange={handleChange}
                          error={touched.invoiceNo && errors.invoiceNo}
                          showError={showError}
                          required={
                            values.exposureType &&
                            values.exposureType !== "confirmed_order"
                          }
                        />
                        <CustomInput
                          label="Invoice Date"
                          name="invoiceDate"
                          type="date"
                          placeholder="Invoice Date"
                          value={values.invoiceDate}
                          onChange={handleChange}
                          error={touched.invoiceDate && errors.invoiceDate}
                          showError={showError}
                          required={
                            values.exposureType &&
                            values.exposureType !== "confirmed_order"
                          }
                        />
                      </>
                    )}
                    <DueDateSync />
                    <CustomInput
                      label="BL Date"
                      name="blDate"
                      type="date"
                    />

                    <CustomInput
                      label="Payment Terms"
                      name="paymentTerms"
                      type="number"
                      value={values.paymentTerms ?? ""}
                      onChange={(e) =>
                        setFieldValue("paymentTerms", e.target.value)
                      }
                      disabled={selectedExposureType === "shipment"}
                      showError={showError}
                    />

                    <CustomInput
                      label="Due Date"
                      name="dueDate"
                      type="date"
                      disabled
                    />
                    {selectedExposureType === "shipment" ? (
                      <CustomInput
                      name="currency"
                      label="Currency"
                      type="text"
                      disabled
                      value={values.currency}
                      
                      />
                    ):(

                      <CustomInput
                      label="Currency"
                      type={"select"}
                      name="currency"
                      options={currenciesData}
                      value={values.currency}
                      onChange={(selectedOption) =>
                        handleChange({
                          target: {
                            name: "currency",
                            value: selectedOption,
                          },
                        })
                      }
                      error={touched.currency && errors.currency}
                      showError={showError}
                      required={true}
                      disabled={selectedExposureType === "shipment"}
                      />
                    )}
                    <CustomInput
                      label="Amount"
                      name="amount"
                      placeholder="Enter Amount"
                      type="number"
                      value={values.amount}
                      onChange={handleChange}
                      error={touched.amount && errors.amount}
                      showError={showError}
                      required={true}
                    />

 
                    <CustomInput
                      label="Budget Rate"
                      name="budgetRate"
                      type="number"
                      value={values.budgetRate}
                      onChange={handleChange}
                      error={touched.budgetRate && errors.budgetRate}
                      showError={showError}
                      disabled={selectedExposureType === "shipment"}
                      required={true}
                    />

                  </SimpleGrid>
                  <MultiHedgeDealExport
                    url={url}
                    showError={showError}
                    exposureType={'export'}
                  />
                  <CustomInput
                    label="Remark"
                    name="remark"
                    type="textarea"
                    placeholder="Enter Remarks"
                    value={values.remark}
                    onChange={handleChange}
                    error={touched.remark && errors.remark}
                    showError={showError}
                  />
    </>
    )}
                  <Flex justify={"end"}>
                    <Button
                      rounded={"full"}
                      fontWeight={500}
                      {...primaryButtonStyle}
                      _hover={{ ...primaryButtonHoverStyle, border: "1px solid" }}
                      transition={"transform 0.3s ease-in-out"}
                      onClick={() => handleFormSubmit(handleSubmit, errors)}
                      size="lg"
                      isLoading={isSubmitting || editLoading}
                    >
                    {isEdit ? "Update" : "Submit"}
                    </Button>
                  </Flex>
                </VStack>
              </FormikForm>
            )
          }}
        </Formik>
      )}
    </Box>
  );
};

export default ExposureForm;